/**
 * Sky setup — a procedural skydome with the Babylon SkyMaterial.
 *
 * Issue #2 mandates "Bodenfläche und Himmel"; SkyMaterial gives us a
 * Daggerfall-friendly look (atmospheric scattering + sun position) without
 * any texture files.  Requires `@babylonjs/materials`.
 */

import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { Scene } from '@babylonjs/core/scene';
import { SkyMaterial } from '@babylonjs/materials/sky/skyMaterial';

export function buildSky(scene: Scene): void {
  const sky = new SkyMaterial('skyMaterial', scene);
  sky.backFaceCulling = false;
  sky.turbidity = 10;
  sky.luminance = 0.5;
  sky.inclination = 0.3;
  sky.azimuth = 0.25;
  sky.rayleigh = 2;
  sky.useSunPosition = false;

  const skybox = MeshBuilder.CreateBox('skyBox', { size: 1000 }, scene);
  skybox.material = sky;
  skybox.infiniteDistance = true;
  skybox.isPickable = false;
  // Don't let the sky participate in shadow / collision calculations.
  skybox.receiveShadows = false;
}
